import { render, staticRenderFns } from "./NavbarAdminMenu.vue?vue&type=template&id=03c68f72"
import script from "./NavbarAdminMenu.vue?vue&type=script&lang=js"
export * from "./NavbarAdminMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports